import { useLayoutEffect } from "react";

export const getMpcLargeModalDimensions = () => {
  const viewportWidth = window.innerWidth;

  if (viewportWidth < 576) {
    return {
      width: "calc(100% - 1rem)",
      height: "92vh"
    };
  }

  if (viewportWidth < 992) {
    return {
      width: "94%",
      height: "82vh"
    };
  }

  return {
    width: "70%",
    height: "70vh"
  };
};

const applyLargeModalSize = (modalRoot, dimensions) => {
  if (!modalRoot || !dimensions) {
    return;
  }

  const dialog = modalRoot.querySelector(".modal-dialog");
  const content = modalRoot.querySelector(".modal-content");

  if (dialog) {
    dialog.style.setProperty("width", dimensions.width, "important");
    dialog.style.setProperty("max-width", dimensions.width, "important");
    dialog.style.setProperty("margin-left", "auto", "important");
    dialog.style.setProperty("margin-right", "auto", "important");
  }

  if (content) {
    content.style.setProperty("width", "100%", "important");
    content.style.setProperty("height", dimensions.height, "important");
    content.style.setProperty("max-height", dimensions.height, "important");
  }
};

const clearLargeModalSize = (modalRoot) => {
  if (!modalRoot) {
    return;
  }

  const dialog = modalRoot.querySelector(".modal-dialog");
  const content = modalRoot.querySelector(".modal-content");

  if (dialog) {
    dialog.style.removeProperty("width");
    dialog.style.removeProperty("max-width");
    dialog.style.removeProperty("margin-left");
    dialog.style.removeProperty("margin-right");
  }

  if (content) {
    content.style.removeProperty("width");
    content.style.removeProperty("height");
    content.style.removeProperty("max-height");
  }
};

export const useMpcLargeModalSize = (isOpen, modalRef) => {
  useLayoutEffect(() => {
    if (!isOpen) {
      return undefined;
    }

    const run = () => {
      applyLargeModalSize(modalRef?.current, getMpcLargeModalDimensions());
    };

    run();
    const frameId = window.requestAnimationFrame(run);
    const timeoutId = window.setTimeout(run, 50);
    window.addEventListener("resize", run);
    window.addEventListener("orientationchange", run);

    return () => {
      window.cancelAnimationFrame(frameId);
      window.clearTimeout(timeoutId);
      window.removeEventListener("resize", run);
      window.removeEventListener("orientationchange", run);
      clearLargeModalSize(modalRef?.current);
    };
  }, [isOpen, modalRef]);
};
